import { createParser } from "nuqs";

/**
 * Сериализует значение в строку формата `Base64(JSON)`.
 */
export function serializeBase64Json(value: unknown): string {
    const json = JSON.stringify(value);
    const encoded = new TextEncoder().encode(json);
    return btoa(String.fromCharCode(...encoded));
}

/**
 * `nuqs`-parser для объекта в URL как `Base64(JSON)` (формат legacy `flt`).
 */
export function parseAsBase64Json<T>(validate?: (parsed: unknown) => T): ReturnType<typeof createParser<T>> {
    return createParser<T>({
        parse: (value) => {
            try {
                const decodedUint8 = Uint8Array.from(atob(value), (char) => char.charCodeAt(0));
                const decodedJson = new TextDecoder().decode(decodedUint8);
                const parsed: unknown = JSON.parse(decodedJson);

                if (validate != null) {
                    return validate(parsed);
                }
                if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
                    return null;
                }
                // TODO(types): narrow parsed object without assertion when filter schemas are explicit
                return parsed as T;
            } catch (error) {
                console.error("Error parsing base64 JSON query param:", error);
                return null;
            }
        },
        serialize: (value) => serializeBase64Json(value),
        eq: (left, right) => JSON.stringify(left) === JSON.stringify(right),
    });
}
